import { useSelector } from "react-redux";
import React from "react";
import { selectVar } from "../../store/conf/confSlice.js";
import {
  TYPE_CONSIGLIATI,
  TYPE_CONTINUA,
  TYPE_ULTIMI,
  TYPE_FAVORITI,TYPE_PREFERITI,
  TYPE_CATEGORIA,
  DEFAULT
} from "../../constants/mediaTypes.js"

function MediaMainBG({ type,coverImage }) {
  const bkgRaccomandati = useSelector(selectVar("_BKG_RACCOMANDATI",DEFAULT));
  const bkgDaterminare = useSelector(selectVar("_BKG_DATERMINARE",DEFAULT));
  const bkgUltimiInseriti = useSelector(selectVar("_BKG_ULTIMI_INSERITI",DEFAULT));
  const bkgFavoriti = useSelector(selectVar("_BKG_FAVORITI",DEFAULT));
  const bkgCategoria = useSelector(selectVar("_BKG_CATEGORIA",DEFAULT));
  let backgroundImages;
  console.log("MediaMainBG type:",type);
  switch ((type || "").toUpperCase()) {
    case TYPE_CATEGORIA:
      backgroundImages = bkgCategoria;
      break;
    case TYPE_CONSIGLIATI:
      backgroundImages = bkgRaccomandati;
      break;
    case TYPE_CONTINUA:
      backgroundImages = bkgDaterminare;
      break;
    case TYPE_ULTIMI:
      backgroundImages = bkgUltimiInseriti;
      break;
    case TYPE_FAVORITI:
    case TYPE_PREFERITI:
      backgroundImages = bkgFavoriti;
      break;
    default:
      backgroundImages = "/explore-bg.jpeg"; // fallback
      break;
  }
  console.log("MediaMainBG backgroundImages:", (type || "").toUpperCase(), backgroundImages);
  const img = coverImage || backgroundImages;
  const style = {
    backgroundImage: `url(${img})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }

  return (
    <div
      className={`h-[15rem] sm:h-[20rem] md:h-[30rem] bg-[610px_auto] sm:bg-[738px_auto] md:bg-[920px_auto] lg:bg-[1174px_auto] xl:bg-[1815px_auto] 
      animate-mainPageBg sm:animate-mainPageBgSM md:animate-mainPageBgMD lg:animate-mainPageBgLG xl:animate-mainPageBgXL relative mb-20`}
      style={style}
    >
      <div className="absolute inset-0 bg-featured-gradient-3" />
    </div>
  );
}

export default MediaMainBG;
